// web/src/features/profile/hooks/useInviteFamilyContact.ts
//
// POST mutation for inviting a new family contact. On success, invalidates the
// affected player's family-list cache so the new entry appears. Web port of the
// mobile hook (shared RQ + service, framework-agnostic).
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { queryKeys } from '@sportninja/common/config/queryKeys'
import {
  inviteFamilyContact,
  type InviteFamilyContactInput,
  type InviteFamilyContactResponse,
} from '@sportninja/common/services/player/inviteFamilyContact'

export const useInviteFamilyContact = () => {
  const queryClient = useQueryClient()
  return useMutation<
    InviteFamilyContactResponse,
    Error,
    InviteFamilyContactInput
  >({
    mutationFn: inviteFamilyContact,
    // Override the global mutations.retry=1 default (see queryClient config).
    retry: 0,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.playerFamily.byPlayer(variables.playerId),
      })
    },
  })
}
